<script setup>
const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  label: {
    type: String,
    default: null,
  },
  icon: {
    type: String,
    default: 'mdi-dots-horizontal',
  }
});
</script>

<template>
  <v-menu :close-on-content-click="true" offset-y>
    <template v-slot:activator="{ props }">
      <v-btn
          variant="outlined"
          color="rgb(var(--v-theme-charcoal))"
          size="small"
          depressed
          v-bind="props"
      >
        <v-icon>{{ icon }}</v-icon>
        <template v-if="label != null">
          {{ label }}
        </template>
        <v-icon size="x-small" class="ml-1">mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-list class="pa-0" density="compact">
      <v-list-item
          v-for="(item, itemKey) in items"
          :key="item.title + itemKey"
          :exact="true"
          @click="() => item.click ? item.click() : null"
          :to="item.route">
        <v-list-item-title>
          <v-icon v-if="item.icon" size="x-small" :icon="item.icon"></v-icon>
          <v-progress-circular v-if="item.loading" size="x-small" indeterminate color="primary"></v-progress-circular>
          {{ item.title }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
